import { render } from "./Attendance.vue?vue&type=template&id=56dc9ec5"
import script from "./Attendance.vue?vue&type=script&lang=js"
export * from "./Attendance.vue?vue&type=script&lang=js"

import "./Attendance.vue?vue&type=style&index=0&id=56dc9ec5&lang=css"

import exportComponent from "/var/www/html/youthmanna/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__